import { Button, ButtonProps } from "components/Buttons/Button";

type PrimaryButtonProps = Omit<ButtonProps, "color">;

export const PrimaryButton = (props: PrimaryButtonProps) => {
  return <Button {...props} />;
};
